import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-hallsweep",
	templateUrl: "./hall-sweep.component.html",
})
export class HallSweepComponent {}
